export default __webpack_public_path__ + "static/media/home-creative-portfolio-img-07.11982f3c.jpg";